module.exports = __webpack_public_path__ + "static/img/yangrou.a36cd353.png";